import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDatabase01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.415 13.5c.12 0 .233.053.317.139.111.114.23.218.35.314.579.459 1.355.827 2.226 1.118C7.061 15.656 9.423 16 12 16s4.939-.344 6.692-.929c.87-.29 1.647-.66 2.226-1.118.12-.096.239-.2.35-.314a.447.447 0 0 1 .317-.139c.23 0 .415.186.415.415V19c0 .85-.513 1.502-1.082 1.953-.579.459-1.355.827-2.226 1.118-1.753.585-4.115.929-6.692.929s-4.939-.344-6.692-.929c-.87-.29-1.647-.66-2.226-1.118C2.513 20.502 2 19.849 2 19v-5.085c0-.23.186-.415.415-.415Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.912 3.047C21.482 3.496 22 4.148 22 5v5c0 .85-.513 1.502-1.082 1.953-.579.459-1.355.827-2.226 1.118-1.753.585-4.115.929-6.692.929s-4.939-.344-6.692-.929c-.87-.29-1.647-.66-2.226-1.118C2.513 11.502 2 10.849 2 10V5c0-.852.519-1.504 1.088-1.953.581-.458 1.36-.826 2.232-1.117C7.075 1.345 9.437 1 12 1c2.563 0 4.925.345 6.68.93.873.29 1.651.66 2.232 1.117ZM4 5l.003-.015a.296.296 0 0 1 .032-.066c.043-.07.13-.174.291-.301.33-.26.87-.539 1.626-.79C7.454 3.326 9.592 3 12 3s4.546.327 6.048.827c.756.252 1.296.53 1.626.79.162.128.248.232.29.302.021.033.03.055.033.066A.06.06 0 0 1 20 5s0 .006-.003.015a.293.293 0 0 1-.032.066c-.043.07-.13.174-.291.301-.33.26-.87.539-1.626.79C16.546 6.674 14.408 7 12 7s-4.546-.327-6.048-.827c-.756-.252-1.296-.53-1.626-.79a1.236 1.236 0 0 1-.29-.302.296.296 0 0 1-.033-.066A.066.066 0 0 1 4 5Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgDatabase01.displayName = 'Database01';
export default SvgDatabase01;
